import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { AppRoutingModule } from '../app-routing.module';
import { UserEmailChangeConfirmationComponent } from '../auth/user-email-change-confirmation/user-email-change-confirmation.component';
import { FooterLinksModule } from '../footer-links/footer-links.module';
import { SharedModule } from '../shared/shared.module';
import { AlertsComponent } from './alerts/alerts.component';
import { ConfigViewerComponent } from './config-viewer/config-viewer.component';
import { CoreRoutingModule } from './core-routing.module';
import { DashboardRootComponent } from './dashboard-root/dashboard-root.component';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { FooterComponent } from './footer/footer.component';
import { MailCenterComponent } from './mail-center/mail-center.component';
import { PinInfoComponent } from './pin-info/pin-info.component';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { WeatherComponent } from './weather/weather.component';
import { WhatsNewComponent } from './whats-new/whats-new.component';
import { DialogModule } from 'primeng/primeng';

@NgModule({
    declarations: [
        TopMenuComponent,
        DashboardRootComponent,
        AlertsComponent,
        FooterComponent,
        MailCenterComponent,
        WeatherComponent,
        UserEmailChangeConfirmationComponent,
        DocumentViewerComponent,
        PinInfoComponent,
        ConfigViewerComponent,
        WhatsNewComponent
    ],
    imports: [
        FormsModule,
        SharedModule,
        CoreRoutingModule,
        AppRoutingModule,
        FooterLinksModule,
        DialogModule,
        NgxJsonViewerModule
    ],
    exports: [
        AppRoutingModule,
        TopMenuComponent,
        DashboardRootComponent,
        MailCenterComponent,
        FooterComponent,
        DocumentViewerComponent,
        WhatsNewComponent,
    ]
})
export class CoreModule {
}
